import { render } from "./Count.vue?vue&type=template&id=5c0160aa&scoped=true"
import script from "./Count.vue?vue&type=script&lang=js"
export * from "./Count.vue?vue&type=script&lang=js"

import "./Count.vue?vue&type=style&index=0&id=5c0160aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0160aa"]])

export default __exports__